/**
 * Settings Context Exports
 *
 * @since 1.0.0
 */

export { SettingsProvider, useSettingsContext } from './component';
export type { SettingsContextType, SettingsProviderProps } from './types';
